module.exports = __webpack_public_path__ + "static/map-tablet-c5ff69f4eec505119b5f180409fc9969.png";